var _ellipse, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconArticle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 39,
    viewBox: "0 0 41 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.2167,
    cy: 19.5,
    rx: 19.9025,
    ry: 19.5,
    fill: "#1CF8BD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1743 15.2H11.5413V26.4C11.5413 27.28 12.2761 28 13.1743 28H24.6055V26.4H13.1743V15.2ZM26.2385 12H16.4403C15.5422 12 14.8073 12.72 14.8073 13.6V23.2C14.8073 24.08 15.5422 24.8 16.4403 24.8H26.2385C27.1367 24.8 27.8715 24.08 27.8715 23.2V13.6C27.8715 12.72 27.1367 12 26.2385 12ZM25.422 19.2H17.2569V17.6H25.422V19.2ZM22.1559 22.4H17.2569V20.8H22.1559V22.4ZM25.422 16H17.2569V14.4H25.422V16Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArticle);
export default __webpack_public_path__ + "static/media/icon_article.5a018bfc441a9b66f877305ffc9d9cfe.svg";
export { ForwardRef as ReactComponent };